import { useState, useCallback } from 'react';
import { handleApiError } from '../services/api';

const useApi = (apiFunction) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const execute = useCallback(
        async (...params) => {
            try {
                setLoading(true);
                setError(null);
                const response = await apiFunction(...params);
                setData(response.data);
                return response.data;
            } catch (err) {
                const errorData = handleApiError(err);
                setError(errorData);
                throw errorData;
            } finally {
                setLoading(false);
            }
        },
        [apiFunction]
    );

    return {
        data,
        loading,
        error,
        execute
    };
};

export default useApi; 